<template>
  <div v-if="open" class="w-full min-w-0 rounded-[24px] bg-white p-4 text-dark shadow-sm sm:rounded-[32px] sm:p-8">
      <div class="mb-6 flex items-center justify-between gap-4 sm:mb-10">
        <button
          type="button"
          class="flex h-11 w-11 items-center justify-center rounded-full text-[22px] text-dark transition hover:bg-light"
          @click="$emit('previous-month')"
        >
          ‹
        </button>
        <div class="text-[18px] font-semibold md:text-[20px]">{{ title }}</div>
        <button
          type="button"
          class="flex h-11 w-11 items-center justify-center rounded-full bg-light text-[22px] text-dark transition hover:opacity-90"
          @click="$emit('next-month')"
        >
          ›
        </button>
      </div>

      <div class="grid grid-cols-7 gap-y-2 text-center text-[14px] font-medium text-dark/70">
        <div v-for="weekday in weekdays" :key="weekday">{{ weekday }}</div>
      </div>

      <div class="mt-6 grid min-w-0 grid-cols-7 gap-y-2 text-center sm:mt-8 sm:gap-y-4">
        <button
          v-for="day in days"
          :key="day.value"
          type="button"
          class="mx-auto flex aspect-square w-full max-w-11 min-w-0 items-center justify-center rounded-full text-[15px] transition"
          :class="dayClass(day)"
          :disabled="day.disabled"
          @click="$emit('select-day', day.value)"
        >
          {{ day.date.date() }}
        </button>
      </div>

      <div class="mt-6 flex items-center justify-between gap-4 sm:mt-10">
        <button
          type="button"
          class="text-[16px] font-semibold underline underline-offset-4"
          @click="$emit('close')"
        >
          Cancel
        </button>
        <button
          type="button"
          class="rounded-full bg-primary px-8 py-4 text-[16px] font-semibold text-dark transition hover:opacity-90"
          @click="$emit('save')"
        >
          Save
        </button>
      </div>
  </div>
</template>

<script setup>
const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    required: true,
  },
  weekdays: {
    type: Array,
    default: () => [],
  },
  days: {
    type: Array,
    default: () => [],
  },
  selectedValue: {
    type: String,
    default: '',
  },
})

defineEmits(['close', 'save', 'previous-month', 'next-month', 'select-day'])

const dayClass = (day) => {
  if (day.disabled) {
    return 'cursor-not-allowed text-dark/25'
  }

  if (props.selectedValue === day.value) {
    return 'bg-light font-semibold text-dark'
  }

  return day.muted ? 'text-dark/35' : 'text-dark hover:bg-light'
}
</script>
